import { useMappedPropsOptions as r } from "./td-longtail-vue-components153.js";
import a from "./td-longtail-vue-components6.js";
import o from "./td-longtail-vue-components33.js";
import s from "./td-longtail-vue-components27.js";
import d from "./td-longtail-vue-components28.js";
import g from "./td-longtail-vue-components29.js";
/* empty css                              */
import n from "./td-longtail-vue-components98.js";
const m = {
  name: "ImageTextGridRow",
  components: {
    GridColumn: g,
    GridRow: d,
    GridContainer: s,
    Heading: a,
    Badge: o
  },
  mixins: [
    r(a, "heading", {
      tag: "h2"
    })
  ],
  props: {
    imageAlignment: {
      type: String,
      default: "left",
      validator: (i) => ["left", "right"].includes(i)
    },
    badgePosition: {
      type: Object,
      default: () => ({
        top: -75,
        right: "20%"
      })
    },
    badgePositionMobile: {
      type: Object,
      default: () => ({
        top: -50,
        right: 20
      })
    }
  },
  computed: {
    imageOrder() {
      return this.imageAlignment === "left" ? "first" : "last";
    }
  }
};
var l = function() {
  var t = this, e = t._self._c;
  return e("grid-container", { staticClass: "image-text-grid-row", class: `image-text-grid-row--order-image-${t.imageOrder}`, attrs: { "is-fluid": "" } }, [e("grid-row", { staticClass: "image-text-grid-row__columns" }, [e("grid-column", { staticClass: "image-text-grid-row__column-image", class: `image-text-grid-row__column-image--order-${t.imageOrder}`, attrs: { xs: 12, md: 8, lg: 9 } }, [e("div", { staticClass: "image-text-grid-row__image" }, [t._t("image"), t.$slots.badge ? e("badge", { staticClass: "image-text-grid-row__badge", style: {
    "--badge-xs-padding": "1em",
    "--badge-sm-padding": "1em"
  }, attrs: { "position-default": t.badgePosition, "position-mobile": t.badgePositionMobile, "default-font-size": 28, "mobile-font-size": 20, "mobile-breakpoint": "lg", "data-testid": "badge" } }, [t._t("badge")], 2) : t._e()], 2)]), e("grid-column", { staticClass: "image-text-grid-row__column-content", attrs: { xs: 12, md: 4, lg: 3 } }, [t.$slots.topline ? e("heading", { staticClass: "image-text-grid-row__topline", attrs: { tag: "strong", size: "xs", "data-testid": "topline" } }, [t._t("topline")], 2) : t._e(), t._t("headingContainer", function() {
    return [e("heading", t._b({ staticClass: "image-text-grid-row__heading", attrs: { "data-testid": "heading" } }, "heading", t.mappedHeadingProps, !1), [t._t("heading")], 2)];
  }), e("div", { staticClass: "image-text-grid-row__copy", attrs: { "data-testid": "copy" } }, [t._t("copy")], 2)], 2)], 1)], 1);
}, _ = [], p = /* @__PURE__ */ n(
  m,
  l,
  _,
  !1,
  null,
  "f05c161f"
);
const v = p.exports;
export {
  v as default
};
